var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 406,
    height: 384,
    viewBox: "0 0 406 384",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_637_87153)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M288.763 85.0633C287.56 81.473 284.037 79.0312 280.054 79.0312H82.9267C78.7101 79.0312 75.712 82.911 76.9867 86.7136L154.799 318.979L154.896 319.235C249.977 319.192 367.131 318.979 367.131 318.979L288.763 85.0633Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.799 318.975L76.9875 86.7097C75.7128 82.9071 78.7109 79.0273 82.9275 79.0273H72.3273C67.8302 79.0273 64.6332 83.1629 65.9895 87.2212L143.633 318.975L143.715 319.236C147.401 319.236 151.133 319.236 154.896 319.236L154.799 318.98V318.975Z",
    fill: "#E9EEF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.975 135.898H119.93L131.019 169.002H171.065L159.975 135.898Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.977 135.898L171.066 169.002H211.107L200.017 135.898H159.977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.153 169L262.243 202.104H302.284L291.194 169H251.153Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.106 169L222.196 202.104H262.242L251.152 169H211.106Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.069 169H131.023L142.118 202.104H182.159L171.069 169Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.111 169H171.07L182.16 202.104H222.201L211.111 169Z",
    fill: "#A3C5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.382 235.207H273.342L284.432 268.311H324.472L313.382 235.207Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.272 235.207L244.362 268.311H284.408L273.318 235.207H233.272Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.201 235.207L164.291 268.311H204.331L193.242 235.207H153.201Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.237 235.207L204.327 268.311H244.368L233.278 235.207H193.237Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.247 202.105L273.337 235.209H313.377L302.288 202.105H262.247Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.2 202.105L233.29 235.209H273.336L262.246 202.105H222.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.159 202.105H142.118L153.208 235.209H193.248L182.159 202.105Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.165 202.105L193.255 235.209H233.295L222.205 202.105H182.165Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.613 319.241L65.9746 87.4868C64.6133 83.4285 67.8153 79.293 72.3124 79.293",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.22 110.586L288.756 85.3289C287.553 81.7386 284.029 79.2969 280.047 79.2969H71.4167C66.7615 79.2969 62.8508 82.6121 62.3358 86.9937C59.5325 111.061 44.9595 236.181 42.3241 258.808C42.0892 260.824 40.3843 262.317 38.3542 262.317H0.263672",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6469 299.103C36.2039 311.533 35.332 319.134 35.332 319.24C35.332 319.838 367.128 319.24 367.128 319.24L311.319 152.661C310.451 150.07 312.379 147.391 315.111 147.391H406.001",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.782 319.241L76.9701 86.9753C75.6954 83.1727 78.6935 79.293 82.9101 79.293",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.33 268.574L159.971 136.164",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.36 268.437L251.137 169.266",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.369 268.574L200.01 136.164H119.924L164.288 268.574H324.455L291.186 169.268H131.014",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.734 149.965H244.842",
    stroke: "#F39200",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.102 202.371H302.268",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.486 235.473H313.352",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.691 184.682L198.25 193.223L205.694 176.141",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.188 79.2925C136.483 71.1517 143.285 65.25 151.315 65.25C161.232 65.25 169.268 74.2401 169.268 85.3293C169.268 96.4185 161.227 105.409 151.315 105.409",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.234 79.2925C203.529 71.1517 210.331 65.25 218.361 65.25C228.278 65.25 236.314 74.2401 236.314 85.3293C236.314 96.4185 228.273 105.409 218.361 105.409",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_637_87153"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 405.736,
    height: 384,
    fill: "white",
    transform: "translate(0.263672)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.6acc6977.svg";
export { ForwardRef as ReactComponent };